import { getColor } from '../../colors/colors.alias';
import { constants as Paragraph } from '../Paragraph';
import { VARIANT_MEDIUM, VARIANT_SMALL, ELEMENT_SUBTEXT } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Subtext',
    variants: {
        VARIANT_SMALL,
        VARIANT_MEDIUM,
    },
    elements: {
        ELEMENT_SUBTEXT,
    },
});
export default function getSubtext(transformer, config) {
    const color = getColor(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_SUBTEXT]: {
                styles: {
                    color: color.text.subtle.value,
                },
            },
        },
        variants: {
            [VARIANT_SMALL]: {
                elements: {
                    [ELEMENT_SUBTEXT]: {
                        components: {
                            [Paragraph.NAME]: {
                                variant: Paragraph.variants.VARIANT_SMALL,
                            },
                        },
                    },
                },
            },
            [VARIANT_MEDIUM]: {
                elements: {
                    [ELEMENT_SUBTEXT]: {
                        components: {
                            [Paragraph.NAME]: {
                                variant: Paragraph.variants.VARIANT_MEDIUM,
                            },
                        },
                    },
                },
            },
        },
    });
}
